import { Injectable } from '@angular/core';
import { stringify } from 'querystring';
import { GridParameters, columnn } from './gridParameters';

@Injectable({
  providedIn: 'root'
})
export class OdataUrlParametersService {

  constructor() { }

  orderFilter(columns, order) {
    let filter = "";
    if (columns.length > 0) {
      filter = "&$orderby=";
      for (let i = 0; i < columns.length; i++) {
        if (i > 0) {
          filter += ",";
        }
        filter += columns[i];
        filter += " ";
        if (order[i] == "up") {
          filter += "asc";
        }
        else {
          filter += "desc";
        }
      }
    }
    return filter;
  }

  search(nameOfColumn: string, searchValue: string, previousFilter: string) {
    let filter = previousFilter;
    if (searchValue != "") {
      if (filter != "") {
        filter += " and ";
      }
      filter += "contains(tolower(" + nameOfColumn + "),'" + searchValue.toLowerCase() + "')";
    }
    return filter;
  }

  equalToString(nameOfColumn: string, searchValues: string[], previousFilter: string) {
    let filter = previousFilter;
    if (searchValues != null) {
      searchValues.forEach(element => {
        if (element != "") {
          if (filter != "") {
            filter += " & ";
          }
          filter += nameOfColumn + " eq '" + this.toUnicode(element) + "'";
        }
      });
    }
    return filter;
  }

  equalToNumber(nameOfColumn: string, searchValues: string[], previousFilter: string) {
    let filter = previousFilter;
    if (searchValues != null) {
      searchValues.forEach(element => {
        if (element != "") {
          if (filter != "") {
            filter += " & ";
          }
          filter += nameOfColumn + " eq " + element;
        }
      });
    }
    return filter;
  }

  fromToFilter(nameOfColumn: string, fromToArray: string[], previousFilter: string) {
    let filter = previousFilter;
    if (fromToArray[0] != "" || fromToArray[1] != "") {
      if (fromToArray[0] != "") {
        if (filter != "") {
          filter += " and ";
        }
        filter += nameOfColumn + " ge " + fromToArray[0];
      }
      if (fromToArray[1] != "") {
        if (filter != "") {
          filter += " and ";
        }
        filter += nameOfColumn + " le " + fromToArray[1];
      }
    }
    return filter;
  }

  selectionFilter(column: columnn, previousFilter: string) {
    let filter = previousFilter;
    if (column.picklistSelectedItems.length > 0) {
      if (filter != "") {
        filter += " and ";
      }
      for (let i = 0; i < column.picklistSelectedItems.length; i++) {
        if(column.type == "picklist"){
          filter += column.name + " eq '" + column.picklistSelectedItems[i] + "'";
        }
        if(column.type == "checkboxText"){
          filter += column.name + " eq '" + column.picklistSelectedItems[i] + "'";
        }
        if(column.type == "checkbox"){
          filter += column.name + " eq " + column.picklistSelectedItems[i];
        }
        if(column.type == "picklistText"){
          filter += column.name + " eq " + column.picklistSelectedItems[i];
        }
        if (i < column.picklistSelectedItems.length - 1) {
          filter += " or ";
        }
      }
      filter = `(${filter})`;
    }
    return filter;
  }

  dateFilter(nameOfColumn: string, fromToArray: string[], previousFilter: string) {
    let filter = previousFilter;
    if (fromToArray[0] != null || fromToArray[1] != null) {
      if (fromToArray[0] != null) {
        if (filter != "") {
          filter += " and ";
        }
        let date = new Date(fromToArray[0]);
        filter += nameOfColumn + " ge " + date.toISOString();
      }
      if (fromToArray[1] != null) {
        if (filter != "") {
          filter += " and ";
        }
        let date = new Date(fromToArray[1]);
        date.setDate(date.getDate() + 1);
        filter += nameOfColumn + " lt " + date.toISOString();
      }
    }
    return filter;
  }

  dateMonthFilter(nameOfColumn: string, InputDate: string, previousFilter: string) {

    let filter = previousFilter;
    if (InputDate != null) {
      if (filter != "") {
        filter += " and ";
      }
      let date = new Date(InputDate);
      date.setHours(date.getHours() + 24 - date.getUTCHours());
      let month = date.toISOString().substring(6, 7);
      let year = date.toISOString().substring(0, 4);
      filter += filter += "month(" + nameOfColumn + ") eq " + month + " and " + "year(" + nameOfColumn + ") eq " + year;
    }
    return filter
  }

  dateYearFilter(nameOfColumn: string, InputDate: string, previousFilter: string) {

    let filter = previousFilter;
    if (InputDate != null) {
      if (filter != "") {
        filter += " and ";
      }
      let date = new Date(InputDate);
      date.setHours(date.getHours() + 1);
      let year = date.toISOString().substring(0, 4);

      filter += filter += "year(" + nameOfColumn + ") eq " + year;
    }
    return filter
  }

  toUnicode(value: string){
    const chars = [`#`, `&`, `%`, `+`];
    const uni = [`%23`, `%26`, `%25`, `2B`];
    for(let i = 0; i < value.length; i++){
      for(let ii = 0; ii< chars.length; ii++){
        if(value[i] == chars[ii]){
          value = value.replace(value[i], uni[ii])
          i++;
        }
      }
    }
    console.log(value)
    return value;
  }
}
